import { HStack, Text } from "@chakra-ui/react";
import { forwardRef } from "react";
import { RoomMetadata } from "../auto-generated-clients/content-delivery-client-v3.generated";

interface NavigationBarItemProps {
  room: RoomMetadata;
  selected: boolean;
  onRoomClick: (room: RoomMetadata) => void;
}

export const NavigationBarItem = forwardRef<
  HTMLDivElement,
  NavigationBarItemProps
>(({ room, selected, onRoomClick }, ref) => {
  return (
    <HStack
      _hover={{
        bg: selected ? "secondary.2" : "secondary.1",
        cursor: "pointer",
      }}
      bg={selected ? "secondary.2" : "secondary.0"}
      width={"100%"}
      px={4}
      py={1.5}
      borderRadius={"lg"}
      flexDirection={"row"}
      fontSize={"sm"}
      onClick={() => onRoomClick(room)}
      ref={ref}
    >
      <Text
        alignContent={"center"}
        alignItems={"center"}
      >
        {room.roomName}
      </Text>
    </HStack>
  );
});
